// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__10CAV","errorLogs":"EditorFooter_errorLogs__2ihWU"};